import { TRACK_HEIGHT } from "../../core/layoutConstants";

export function LoadingTag(): React.ReactElement {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{ height: `${TRACK_HEIGHT}px` }}
    >
      <tractie-tag color="gray" appearance="subtle" size="m">
        {"- m"}
      </tractie-tag>
    </div>
  );
}
